import type { VisibilityState } from '@tanstack/react-table';
import { isNil } from 'es-toolkit';

import { getStoredTableValue, getTableLocalStorageKey, setStoredTableValue } from './table-local-storage';

const COLUMN_VISIBILITY_STORAGE_PREFIX = 'savvy-data-table-column-visibility:';

function isRecord(data: unknown): data is Record<string, unknown> {
  return !isNil(data) && typeof data === 'object' && !Array.isArray(data);
}

function isVisibilityState(data: unknown): data is VisibilityState {
  return isRecord(data) && Object.values(data).every((value) => typeof value === 'boolean');
}

export function getColumnVisibilityStorageKey({
  tableName,
  storageKey,
  persist,
}: {
  readonly tableName: string | undefined;
  readonly storageKey: string | undefined;
  readonly persist: boolean;
}) {
  return getTableLocalStorageKey({ prefix: COLUMN_VISIBILITY_STORAGE_PREFIX, tableName, storageKey, persist });
}

export function getStoredColumnVisibility(storageKey: string) {
  return getStoredTableValue(storageKey, isVisibilityState);
}

export function setStoredColumnVisibility({
  storageKey,
  columnVisibility,
}: {
  readonly storageKey: string;
  readonly columnVisibility: VisibilityState;
}) {
  setStoredTableValue(storageKey, columnVisibility);
}
